/**
 * humaniseToken — last-resort readable text for a machine token or catalog key
 * whose localized copy is genuinely missing (§14.2: a raw key or machine
 * identifier must never surface AS copy).
 *
 * It is deliberately NOT a translation: it exists only so a value shipped by
 * the backend AFTER the catalog was written degrades to a readable label
 * instead of a raw `domain.enum.VALUE` key, an empty blank, or a crash. Known
 * values always resolve through the catalog; the contract-driven raw-key sweep
 * asserts that, so this fallback is a safety net, never the normal path.
 *
 *   "drivers.status.PENDING_APPROVAL" → "Pending approval"
 *   "featured_listing"                → "Featured listing"
 *   "driver_plans"                    → "Driver plans"
 */
export function humaniseToken(token: string | null | undefined): string {
  // A `Record<Enum, MessageKey>[value]` lookup that misses hands `t()` an
  // undefined key — a live enum value shipped after the map (the 2026-09-29
  // `request_driver` outage). Nothing to humanise is empty copy, never a crash.
  if (typeof token !== "string") return "";
  const tail = token.slice(token.lastIndexOf(".") + 1);
  const words = tail.replace(/[_-]+/g, " ").trim().toLowerCase();
  if (words === "") return "";
  return words.charAt(0).toUpperCase() + words.slice(1);
}
